"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var components_1 = require("@athena-portal/components");
var React = require("react");
var Tree_1 = require("../../components/Tree");
var HomeWarrantiesTree = /** @class */ (function (_super) {
    __extends(HomeWarrantiesTree, _super);
    function HomeWarrantiesTree(props) {
        var _this = _super.call(this, props) || this;
        _this.renderWarranties = function () {
            var _a, _b, _c, _d;
            var warrantyDisplayList = [];
            if (_this.props.interaction.warranties) {
                var businessUse = (_a = _this.props.interaction.warranties.businessUse) !== null && _a !== void 0 ? _a : false;
                warrantyDisplayList.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Business Use Warranty - ", businessUse ? "Y" : "N"] }) }, "businessUseWarranty"));
                var childmindingWarranty = (_b = _this.props.interaction.warranties.childminding) !== null && _b !== void 0 ? _b : false;
                warrantyDisplayList.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Childminding Warranty - ", childmindingWarranty ? "Y" : "N"] }) }, "childmindingWarranty"));
                var lodgersWarranty = (_c = _this.props.interaction.warranties.lodgers) !== null && _c !== void 0 ? _c : false;
                warrantyDisplayList.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Lodgers Warranty - ", lodgersWarranty ? "Y" : "N"] }) }, "lodgersWarranty"));
                var payingGuestsWarranty = (_d = _this.props.interaction.warranties.payingGuests) !== null && _d !== void 0 ? _d : false;
                warrantyDisplayList.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Paying Guests Warranty - ", payingGuestsWarranty ? "Y" : "N"] }) }, "payingGuestsWarranty"));
            }
            warrantyDisplayList.push((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "Security Warranty - N" }) }, "securityWarranty"));
            return warrantyDisplayList;
        };
        return _this;
    }
    HomeWarrantiesTree.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Tree_1.Tree, { label: "Warranties", children: this.renderWarranties() }));
    };
    HomeWarrantiesTree = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], HomeWarrantiesTree);
    return HomeWarrantiesTree;
}(React.Component));
exports.default = HomeWarrantiesTree;
//# sourceMappingURL=HomeWarrantiesTree.js.map